import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import RechercheApi from '../api/RechercheApi';
import '../fichierCss/ResultatsRecherche.css';

const ResultatsRechercheContainer = () => {
    const [searchParams] = useSearchParams();
    const terme = searchParams.get('terme') || '';
    const [resultats, setResultats] = useState([]);
    const [chargement, setChargement] = useState(false);

    useEffect(() => {
        if (!terme) {
            setResultats([]);
            return;
        }
        setChargement(true);
        RechercheApi.rechercher(terme)
            .then(setResultats)
            .catch(() => setResultats([]))
            .finally(() => setChargement(false));
    }, [terme]);

    return (
        <div className="resultats-recherche">
            <h2 className="resultats-titre">
                Résultats pour <span className="resultats-terme">« {terme} »</span>
            </h2>

            {chargement && <p className="resultats-chargement">Chargement…</p>}

            {!chargement && resultats.length === 0 && terme && (
                <p className="resultats-vide">Aucun résultat trouvé pour « {terme} ».</p>
            )}

            {!chargement && resultats.length > 0 && (
                <ul className="resultats-liste">
                    {resultats.map((r) => (
                        <li key={`${r.type}-${r.id}`} className="resultats-item">
                            <Link
                                to={String(r?.type || '').toLowerCase() === 'ressource' ? `/contenu-generique?id=${encodeURIComponent(r.id || '')}` : r.lien}
                                className="resultats-lien"
                            >
                                <span className="resultats-badge">{r.type}</span>
                                <strong className="resultats-item-titre">{r.titre}</strong>
                                {r.sousTitre && (
                                    <span className="resultats-sous-titre">{r.sousTitre}</span>
                                )}
                            </Link>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default ResultatsRechercheContainer;
